import moment from "moment";
import { useSelector } from "react-redux";

const CheckInAvailabilty = ({ eventData }) => {
  const user = useSelector((store) => store.user);
  const dateFromFormatter = moment(eventData?.start).tz(user?.timezone).format("DD-MMM-YYYY");

  const formatTime = (date) => {
    return moment(date).tz(user?.timezone).format("hh:mm a");
  };
  try {
    const formattedStartDate = dateFromFormatter;
    const formatted = {
      before: formatTime(eventData?.checkInStartsAt * 1000),
      after: formatTime(eventData?.checkInEndsAt * 1000),
    };
    return (
      <span>
        Check-in is available in {formattedStartDate}, between {formatted.before} - {formatted.after}
      </span>
    );
  } catch (e) {
    console.error(e);
    return (
      <>
      </>
    );
  }
}

export default CheckInAvailabilty
